// Typescript:
interface PedagogyArrType {
    id: number
    title: string
    icon: string
}

const Pedagogy = () => {
    // Constant:
    const pedagogyArr = [
        {
            id:0,
            title: 'Task based framework with adequate hands-on application of the learnings',
            icon: '/assets/pedagogy-1.png',
        },
        {
            id:1,
            title: 'Masterclass with Industry expert',
            icon: '/assets/pedagogy-2.png',
        },
        {
            id:2,
            title: 'Live interactive programs',
            icon: '/assets/pedagogy-3.png',
        },
        {
            id:3,
            title: 'In class assessments to measure engagement and knowledge transfer',
            icon: '/assets/pedagogy-4.png',
        },
        {
            id:4,
            title: 'Action learning projects',
            icon: '/assets/pedagogy-5.png',
        },
        {
            id:5,
            title: 'Shark-Tank like Presentations',
            icon: '/assets/pedagogy-6.png',
        },
        {
            id:6,
            title: 'Renowned industry professionals to conduct trainings',
            icon: '/assets/pedagogy-7.png',
        },
        {
            id:7,
            title: 'Small batch size for dedicated attention',
            icon: '/assets/pedagogy-8.png',
        },
        {
            id:8,
            title: 'Career Counseling & Mentorship',
            icon: '/assets/pedagogy-9.png',
        },
    ]
    return <div className='col-[2_/_3] my-[4rem] flex flex-col items-center'>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[40px]'>Our Pedagogy</h2>
        <div className='flex gap-[30px] flex-wrap justify-center'>
            {pedagogyArr?.map((pedagogy:PedagogyArrType)=><div className='basis-[100%] md:basis-[46%] lg:basis-[25%] lg:flex-1 bg-[#DFD4FF] rounded-[20px] flex gap-[20px] flex-wrap lg:flex-nowrap justify-center items-center p-[16px] border-solid border-[2px] border-[#9774FF]' key={pedagogy?.id}>
                <img src={pedagogy?.icon} alt='pedagogy'/>
                <p className='basis-[73%] text-[18px] lg:text-[20px] font-semibold'>{pedagogy?.title}</p>
            </div>)}
        </div>
    </div>
}

export default Pedagogy